import React, { useEffect, useState } from 'react';
import { Suspenser } from './newStyledComponents/Suspenser/Suspenser';
import i18n from 'i18next';
import './i18n';

const I18NInitalize = ({ children }) => {
  const [state, setState] = useState(false);

  useEffect(() => {
    i18n.on('initialized', (options) => {
      setState(true);
    });
  }, []);

  return (
    <Suspenser show={state}>
      {children}
    </Suspenser>
  );
};

export default I18NInitalize;
